// A aba de conversas da ficha 360. (#880)

import { type ReactNode } from 'react';
import type { Cliente360, ConversaDo360 } from '@cliqcrm/contracts';
import { nomeDoCanal } from '@/entities/atendimento/canal';
import { NOMES_DE_SITUACAO } from '@/entities/atendimento/conversa';
import { Defasado, Vazio } from '@/shared/ui/estados/estados';
import { idadeEmPalavras } from '@/shared/ui/estados/idade';
import { Etiquetas } from '@/entities/atendimento/etiqueta';
import { Chip, ListaLinha, NaoLidas, Tabela } from '@/shared/ui';

export function PainelDeConversas({
  lista,
  aoAbrir,
}: {
  lista: Cliente360['conversas'];
  aoAbrir: (conversaId: string) => void;
}): ReactNode {
  if (lista.itens.length === 0) {
    return (
      <Vazio
        titulo="Nenhuma conversa ainda"
        porque="Este cliente não falou por canal nenhum — provavelmente veio de importação ou de conector."
      />
    );
  }

  const nomeDaCaixa = (c: ConversaDo360): string => c.caixa ?? nomeDoCanal(c.canal) ?? 'Conversa';

  return (
    <>
      {lista.frescor.stale && (
        <Defasado projetadoEm={lista.frescor.projetado_em} origem="Esta lista" />
      )}

      <div className="c360__so-mouse">
        <Tabela
          rotulo="Conversas deste cliente"
          colunas={[
            { chave: 'canal', rotulo: 'Canal' },
            { chave: 'situacao', rotulo: 'Situação' },
            { chave: 'ultima', rotulo: 'Última mensagem' },
            { chave: 'etiquetas', rotulo: 'Etiquetas' },
            { chave: 'naoLidas', rotulo: 'Não lidas', numero: true },
          ]}
          chaveDe={(_, i) => lista.itens[i]!.id}
          linhas={lista.itens.map((c) => ({
            /*
             * Quem ABRE é um botão na primeira célula, e não a fileira.
             *
             * Uma fileira clicável não recebe foco nem tabulação: no mouse
             * funciona, no teclado a linha simplesmente não existe.
             */
            canal: (
              <button type="button" className="c360__abrir" onClick={() => aoAbrir(c.id)}>
                {nomeDaCaixa(c)}
              </button>
            ),
            situacao: <Chip>{NOMES_DE_SITUACAO[c.situacao] ?? c.situacao}</Chip>,
            ultima: c.ultima_mensagem_em ? idadeEmPalavras(c.ultima_mensagem_em) : '—',
            etiquetas: <Etiquetas titulos={c.etiquetas ?? []} limite={3} />,
            naoLidas: <NaoLidas quantidade={c.nao_lidas} />,
          }))}
        />
      </div>

      <ul className="c360__lista c360__so-cel">
        {lista.itens.map((c) => (
          <ListaLinha
            key={c.id}
            densa
            aoAbrir={() => aoAbrir(c.id)}
            rotulo={`Abrir a conversa de ${nomeDaCaixa(c)}`}
            nome={nomeDaCaixa(c)}
            previa={c.ultima_mensagem_em ? idadeEmPalavras(c.ultima_mensagem_em) : undefined}
            meta={
              <span className="c360__lista-meta">
                <Chip>{NOMES_DE_SITUACAO[c.situacao] ?? c.situacao}</Chip>
                <Etiquetas titulos={c.etiquetas ?? []} limite={2} />
              </span>
            }
            direita={<NaoLidas quantidade={c.nao_lidas} />}
          />
        ))}
      </ul>
    </>
  );
}
